export { TabPanels } from '../src/TabPanels';
